<script setup lang="ts">
withDefaults(
  defineProps<{
    icon: string;
    type: "success" | "warning" | "danger" | "primary" | "grey" | "info" | "ia";
    label: string;
    tooltip?: string;
    clickable?: boolean;
    loading?: boolean;
  }>(),
  {
    clickable: false,
    loading: false,
  }
);

defineEmits<{
  (e: "select"): void;
}>();

const typeClasses = {
  success: "bg-success-light text-success",
  warning: "bg-warning-light text-warning",
  danger: "bg-danger-light text-danger",
  primary: "bg-primary-light text-primary",
  info: "bg-info-light text-info",
  ia: "bg-ia-light text-ia",
  grey: "badge-inactive  ",
};
</script>

<template>
  <button
    ref="refHook"
    :data-bs-content="tooltip"
    type="button"
    class="py-1 px-2 rounded-sm border-0"
    :class="[
      typeClasses[type],
      {
        clickable,
      },
    ]"
    @click="
      () => {
        if (clickable && !loading) {
          $emit('select');
        }
      }
    "
  >
    <div class="d-flex gap-2 align-items-center">
      <el-tooltip :content="tooltip" effect="light" placement="bottom">
        <div
          v-if="loading"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></div>
        <el-icon v-else size="1.2rem">
          <i :class="icon"></i>
        </el-icon>
      </el-tooltip>

      <div class="text-truncate" style="font-size: 11px">{{ label }}</div>
    </div>
  </button>
</template>

<style lang="scss" scoped>
.badge-inactive {
  cursor: pointer;
  color: #b6b6b6 !important;
  background-color: #b6b6b630 !important;
}

.clickable {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: white !important;
    background-color: var(--bs-dark) !important;
  }
}
</style>
